import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Plus, Trash2, Loader2, Send } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ROLES = [
    ['dispatcher', 'Despachador'], ['pilot', 'Piloto'], ['maintenance', 'Mantenimiento'], ['ccod', 'CCO'],
    ['crew_admin', 'Admin Tripulaciones'], ['counter', 'Mostrador'], ['ramp', 'Rampa'], ['comercial', 'Comercial'],
    ['ventas', 'Ventas'], ['gerencia', 'Gerencia'], ['analista', 'Analista'], ['calidad', 'Calidad'], ['ccm', 'CCM'], ['admin', 'Administrador'],
];
const emptyRow = () => ({ email: '', first_name: '', last_name: '', role: 'dispatcher' });

export const TeamInviteStep = ({ onInvited }) => {
    const [rows, setRows] = useState([emptyRow()]);
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState([]);
    const set = (i, k, v) => setRows(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));

    const sendAll = async () => {
        const valid = rows.filter((r) => r.email && r.first_name);
        if (!valid.length) { toast.error('Agrega al menos un correo y nombre'); return; }
        setBusy(true);
        const failed = [];
        for (const r of valid) {
            try {
                await axios.post(`${API}/auth/register`, { ...r, last_name: r.last_name || '-' });
                setSent((s) => [...s, r.email]);
            } catch (e) {
                const d = e.response?.data?.detail;
                failed.push(r);
                toast.error(`${r.email}: ${typeof d === 'string' ? d : 'no se pudo invitar'}`);
            }
        }
        setRows(failed.length ? failed : [emptyRow()]);
        setBusy(false);
        if (valid.length > failed.length) { toast.success(`${valid.length - failed.length} invitaciones enviadas`); onInvited?.(); }
    };

    return (
        <div className="space-y-3" data-testid="team-invite-step">
            {rows.map((r, i) => (
                <div key={i} className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_1.2fr_auto] gap-2" data-testid={`invite-row-${i}`}>
                    <Input placeholder="correo@aerolinea.com" type="email" value={r.email} onChange={(e) => set(i, 'email', e.target.value)} data-testid={`invite-email-${i}`} />
                    <Input placeholder="Nombre" value={r.first_name} onChange={(e) => set(i, 'first_name', e.target.value)} data-testid={`invite-first-${i}`} />
                    <Input placeholder="Apellido" value={r.last_name} onChange={(e) => set(i, 'last_name', e.target.value)} data-testid={`invite-last-${i}`} />
                    <Select value={r.role} onValueChange={(v) => set(i, 'role', v)}>
                        <SelectTrigger data-testid={`invite-role-${i}`}><SelectValue /></SelectTrigger>
                        <SelectContent>{ROLES.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
                    </Select>
                    <Button variant="ghost" size="icon" onClick={() => setRows(rows.length > 1 ? rows.filter((_, j) => j !== i) : [emptyRow()])} data-testid={`invite-remove-${i}`}><Trash2 className="w-4 h-4" /></Button>
                </div>
            ))}
            <div className="flex flex-wrap gap-2">
                <Button variant="outline" size="sm" onClick={() => setRows([...rows, emptyRow()])} data-testid="invite-add-row"><Plus className="w-4 h-4 mr-1" />Agregar persona</Button>
                <Button size="sm" onClick={sendAll} disabled={busy} data-testid="invite-send-all">{busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Send className="w-4 h-4 mr-1" />}Enviar invitaciones</Button>
            </div>
            {sent.length > 0 && <p className="text-xs text-emerald-500" data-testid="invite-sent-list">Invitados: {sent.join(', ')}</p>}
            <p className="text-xs text-muted-foreground">Cada persona recibe un correo para activar su cuenta y elegir su contraseña.</p>
        </div>
    );
};
